import { svg } from 'lit';

export const chevronForwardIcon = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M10.5303 5.46966C10.2374 5.17677 9.76256 5.17677 9.46967 5.46966C9.2034 5.73593 9.1792 6.15259 9.39705 6.4462L9.46967 6.53032L14.939 12L9.46967 17.4697C9.2034 17.7359 9.1792 18.1526 9.39705 18.4462L9.46967 18.5303C9.73594 18.7966 10.1526 18.8208 10.4462 18.6029L10.5303 18.5303L16.5303 12.5303C16.7966 12.2641 16.8208 11.8474 16.6029 11.5538L16.5303 11.4697L10.5303 5.46966Z" fill="#786E5C"/>
</svg>
`;
